import React, { useState, useEffect } from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";
import QwertyKeyboard from "../utilities/QwertyKeyboard";
import NumericKeyboard from "../utilities/NumericKeyboard";
import { logFunctions as log } from "../../util/Logging";

function EnterLoyaltyCardScreen(props) {
  const [loyaltyCard, setLoyaltyCard] = useState("");
  const { t } = useTranslation("translation");
  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    if (props.searchText && !isEditing) {
      setLoyaltyCard(props.searchText);
    }
    document.getElementById("loyalty_card_number").value = loyaltyCard;
    document.getElementById("loyalty_card_number").focus();
  }, [loyaltyCard, props.searchText, isEditing]);

  function routeToPreviousScreen() {
    log.debug("+EnterLoyaltyCardScreen_routeToPreviousScreen(TRACE)");
    log.info(
      "EnterLoyaltyCardScreen_routeToPreviousScreen() => previous screen name: %s",
      props.previousStateName
    );
    switch (props.previousStateName) {
      case AppState.SCANNER_DETAILS_SCREEN:
        props.transitionToScannerDetailsScreen(undefined, props.devicesList);
        break;
      default:
        props.transitionToAttractScreen();
    }
    log.debug("-EnterLoyaltyCardScreen_routeToPreviousScreen(TRACE)");
  }

  function performKeyBoardClickAction(characterID, value) {
    setIsEditing(true);
    switch (characterID) {
      case "delete":
        backspace();
        break;
      case "space":
        appendTextToTextField(" ");
        break;
      case "Clear":
        clearLoyalityCardText();
        break;
      case "Enter":
        props.processScan(loyaltyCard);
        break;
      default:
        appendTextToTextField(value);
        break;
    }
  }

  function appendTextToTextField(character) {
    setLoyaltyCard(loyaltyCard + character);
  }

  function clearLoyalityCardText() {
    setLoyaltyCard("");
  }

  function backspace() {
    var backspacedString = loyaltyCard.substring(0, loyaltyCard.length - 1);
    setLoyaltyCard(backspacedString);
  }

  return (
    <div className="Screen">
      <div className="contentContainer">
        <div className="contentTitleTextBox" id="enterLoyaltyCardTitleLabel">
          <h4>{t("Enter Your Text")}</h4>
        </div>
        <div className="keyboardContainer">
          <TextField
            autoFocus
            id="loyalty_card_number"
            margin="normal"
            variant="outlined"
            inputProps={{ style: { fontSize: 20 } }} // font size of input text
            className="loyaltyCardTextField"
          />
          <div className="loyaltyScreenKeyPadView">
            <div>
              <QwertyKeyboard onClick={performKeyBoardClickAction} />
            </div>
            <div>
              <NumericKeyboard onClick={performKeyBoardClickAction} />
            </div>
          </div>
        </div>
      </div>
      <div className="footerContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          transitionToPreviousScreen={() => routeToPreviousScreen()}
          state={AppState.ENTER_LOYALTY_CARD_SCREEN}
        />
      </div>
    </div>
  );
}

export default EnterLoyaltyCardScreen;
